import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { quoteToDoubleQuote } from './utils/Columns';

const Mail = () => {
    const [textareaContent, setTextareaContent] = useState('');
    const [subject, setSubject] = useState('');

    const url = localStorage.getItem('url');

    useEffect(() => {
        getMail();
    }, []);

    const getMail = () => {
        fetch(`${url}GetMail`)
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);
                // console.log(data.mail)
                setTextareaContent(data.corps.replace(/¤/g, '\n'));
                setSubject(data.subject);
            })
            .catch(error => console.error('Erreur:', error));
    };

    const handleSaveMail = () => {
        fetch(`${url}SaveMail`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // remplace 'Invalid date' par '' dans le JSON
            body: JSON.stringify(quoteToDoubleQuote({ corps: textareaContent, subject }))
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);
                alert('Sauvegarde effectuée');
            })
            .catch(error => console.error('Erreur:', error));
    }

    const generateMailtoLink = () => {
        const emailAddress = '';
        // const bodyContent = encodeURIComponent(textareaContent.replace(/\n/g, '%0D%0A'));
        const bodyContent = encodeURIComponent(textareaContent);
        const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${bodyContent}`;
        OpenMail(mailtoLink);
    };

    const OpenMail = (lien) => {
        const link = document.createElement('a');
        link.href = lien;
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    };

    const handleSaveSubject = (e) => {
        e.preventDefault();

        setSubject(e.target.value);
        return false;
    }

    return (
        <Container>
            <Row className="mt-5">
                <Col>
                    <h2>Générateur de lien mailto</h2>
                    <p>Utilisez le formulaire ci-dessous pour générer un lien mailto avec le contenu du message :</p>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <Form>
                        <Form.Group controlId="formSubject">
                            <Form.Label>Subject du message :</Form.Label>
                            <Form.Control type="text" value={subject} onChange={handleSaveSubject} />
                        </Form.Group>
                        <Form.Group controlId="formTextarea">
                            <Form.Label>Contenu du message :</Form.Label>
                            <Form.Control as="textarea" rows={7} value={textareaContent} onChange={(e) => setTextareaContent(e.target.value)} onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }} />
                        </Form.Group>
                        <p style={{color : textareaContent.length>1000 ? 'red': '',}}>nb de caracteres : {textareaContent.length}/1000</p>
                        <Button variant="primary" onClick={generateMailtoLink}>
                            Générer le lien mailto
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col>
                    <h2>Enregistrer le contenu du message</h2>
                    <Button variant="primary" onClick={handleSaveMail}>
                        Cela me convient, enregistrer le contenu du message
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default Mail;
